import React from "react";
import { createPortal } from "react-dom";

export default function Portal({ to, children }) {
	if (!to.current) return null;
	return createPortal(<>{children}</>, to.current);
}
